'use strict';

var bignumber_js = require('bignumber.js');

/**
 * Converts big number to its `integer` and `decimal` values.
 */ const convertBigNumber = ({ number, decimalPlaces, padded })=>{
    bignumber_js.BigNumber.config({
        FORMAT: {
            prefix: '',
            decimalSeparator: '.',
            groupSeparator: '',
            groupSize: 3,
            secondaryGroupSize: 0,
            fractionGroupSeparator: ' ',
            fractionGroupSize: 0,
            suffix: ''
        }
    });
    const bigNumber = new bignumber_js.BigNumber(number);
    // `decimalPlaces()` does not add any trailing zeros if they are not needed
    const formatted = padded ? bigNumber.toFormat(decimalPlaces) : bigNumber.decimalPlaces(decimalPlaces).toFormat();
    const [stringNumValue = undefined, decimalValue = undefined] = formatted.split('.');
    return {
        stringNumValue,
        decimalValue
    };
};
const THOUSAND = 1000;
const MILLION = 1000000;
const BILLION = 1000000000;
const TRILLION = 1000000000000;
const classifyAmount = (amount)=>{
    const absAmount = Math.abs(amount);
    if (TRILLION <= absAmount) {
        return {
            numValue: amount / TRILLION,
            denom: 'T'
        };
    } else if (BILLION <= absAmount) {
        return {
            numValue: amount / BILLION,
            denom: 'B'
        };
    } else if (MILLION <= absAmount) {
        return {
            numValue: amount / MILLION,
            denom: 'M'
        };
    } else if (THOUSAND <= absAmount) {
        return {
            numValue: amount / THOUSAND,
            denom: 'K'
        };
    }
    return {
        numValue: amount,
        denom: ''
    };
};

exports.classifyAmount = classifyAmount;
exports.convertBigNumber = convertBigNumber;
//# sourceMappingURL=big.js.map
